"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _illustratedmessage = require("@react-spectrum/illustratedmessage");
var _text = require("@react-spectrum/text");
var _ComponentRegistry = _interopRequireDefault(require("../../../../util/ComponentRegistry"));
require("!style-loader!css-loader!./PreviewError.css");
var _class, _PreviewError;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
let PreviewError = exports.default = (0, _mobxReact.observer)(_class = (_PreviewError = class PreviewError extends _react.default.Component {
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "errorContainer"
    }, /*#__PURE__*/_react.default.createElement(_illustratedmessage.IllustratedMessage, null, _ComponentRegistry.default.getComponent("PreviewErrorIcon"), /*#__PURE__*/_react.default.createElement(_text.Heading, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "errorMessage"
    }, this.props.errorMessage))));
  }
}, _PreviewError.propTypes = {
  errorMessage: _propTypes.default.string.isRequired
}, _PreviewError)) || _class;